import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectNewbuildingName = (state: IApplicationState) => {
  const { name } = selectNewbuilding(state);

  return name;
};
